let pokeColor = [
    { original: "black", material: "#757575" },
    { original: "blue", material: "#42a5f5" },
    { original: "brown", material: "#bcaaa4" },
    { original: "gray", material: "#e0e0e0" },
    { original: "green", material: "#81c784" },
    { original: "pink", material: "#f8bbd0" },
    { original: "purple", material: "#e1bee7" },
    { original: "red", material: "#ef9a9a" },
    { original: "white", material: "#fff" },
    { original: "yellow", material: "#ffe082" },
];
export { pokeColor };
